// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3UQd1","gfeWrapper":"CalendarEvent_gfeWrapper__3yn3n"};